import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=5bd57cca&scoped=true&"
import script from "./Layout.vue?vue&type=script&lang=ts&"
export * from "./Layout.vue?vue&type=script&lang=ts&"
import style0 from "./Layout.vue?vue&type=style&index=0&id=5bd57cca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/registry.nlark.com+vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd57cca",
  null
  
)

export default component.exports